import {BaseModel} from "../../../../infrastructure/models/base-model";
import {AppTerms} from "../../../app/app-terms";
import {DidomiConfigLanguageModel} from "./didomi-config.language-model";
import {DidomiConfigNoticeModel} from "./didomi-config.notice-model";
import {DidomiConfigThemeModel} from "./didomi-config.theme-model";
import {DidomiConfigUserBotsModel} from "./didomi-config.user-bots-model";

export class DidomiConfigModel extends BaseModel {
  terms: AppTerms;
  language: String;
  isRtl: Boolean;

  constructor(terms: AppTerms, language: String, isRtl: Boolean) {
    super();

    this.terms = terms;
    this.language = language;
    this.isRtl = isRtl;
  }

  get user() {
    const userBots: DidomiConfigUserBotsModel = new DidomiConfigUserBotsModel();

    return userBots
  }

  get languages() {
    const languages: DidomiConfigLanguageModel = new DidomiConfigLanguageModel(this.language);

    return languages
  }

  get notice() {
    const notice: DidomiConfigNoticeModel = new DidomiConfigNoticeModel(this.terms, this.isRtl, this.language);

    return notice
  }

  get theme() {
    const theme: DidomiConfigThemeModel = new DidomiConfigThemeModel(this.language);

    return theme;
  }

  getDidomiObject() {
    return {
      languages: this.languages.getDidomiObject(),
      notice: this.notice.getDidomiObject(),
      theme: this.theme.getDidomiObject(),
      user: this.user.getDidomiObject()
    }
  }
}
